import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/illustrations/full-illustration@2x.png")